const initialState = {
        project: false
};

export default initialState;